import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { PublicationControl } from '@/module/Author/Publication/PublicationControl';
import { JournalSelectControl } from '@/module/Nomen/Journal/JournalSelectControl';
import { JournalTypeSelectControl } from '@/module/Nomen/JournalType/JournalTypeSelectControl';

import { TextInputControl } from '@/core/components';

export interface PaperControlProps {
  isSubmitting: boolean;
  showWosFields: boolean;
  showScopusFields: boolean;
}

export function PaperControl(props: PaperControlProps) {
  const { isSubmitting, showWosFields, showScopusFields } = props;
  const { t } = useTranslation();

  return (
    <>
      <Group align="flex-end">
        <JournalSelectControl
          name="journal"
          label={t('papers.form.fields.journal')}
          isSubmitting={isSubmitting}
          withAsterisk
        />
        <JournalTypeSelectControl
          label={t('papers.form.fields.journalType')}
          name="journalType"
          isSubmitting={isSubmitting}
          withAsterisk
        />
      </Group>
      <Group>
        <TextInputControl
          name="volume"
          label={t('papers.form.fields.volume')}
          isSubmitting={isSubmitting}
        />
        <TextInputControl
          name="volumeNo"
          label={t('papers.form.fields.volumeNo')}
          isSubmitting={isSubmitting}
        />
      </Group>
      <PublicationControl
        isSubmitting={isSubmitting}
        showWosFields={showWosFields}
        showScopusFields={showScopusFields}
      />
    </>
  );
}
